<script setup>
import {computed, inject} from 'vue';

const props = defineProps({
  icon: {type: String, required: true},
  filled: {type: Boolean, default: false},
  margin: {type: Boolean, default: true}
})

const classes = computed(() => {
  return [
    'dp-icon',
    props.icon,
    {
      'inline-margin': props.margin,
      'filled': props.filled
    }
  ]
});
</script>
<script>
export default {
  name: "DpIcon"
};
</script>

<template>
  <i :class="classes"/>
</template>
